import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IResponse from '../../../models/responces/IResponse';
import IDataObjectParams from '../../../models/params/IDataObjectParams';

export interface ICRUDReadParams {
  dataObjectName: string;
  id: string | number;
  field?: string;
  dataObjectParams?: IDataObjectParams;
}

const apiRead = (params: ICRUDReadParams) =>
  sendAxiosRequest({
    method: 'get',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'crud',
      dataObjectName: params.dataObjectName,
      field: params.field || 'ID',
      id: params.id,
      dataObjectParams: params.dataObjectParams || undefined
    }),
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IResponse>;
export default apiRead;
